// All mockable content lives here.
// Replace youtubeIds / titles / descriptions here to update the whole site.

export const profile = {
  name: "Evan Lowenberg",
  tagline: "Short-Form Video Creative \u2014 Shoot & Cut",
  brand: "REWIND", // giant hero word
  studio: "Analog Reel", // nav logo text
  bio:
    "Short-form video creative who both shoots and cuts. At Paramount and other companies I have created hundreds of social and YouTube pieces a year, turning show campaigns into clicks and views. Production is something I already work with rather than something I would be learning \u2014 with years of shooting as videographer, AD, and editing experience, I can capture authentic footage myself and turn it into something eye-catching.",
  email: "Lowenberg.films@gmail.com",
  socials: [
    { label: "Instagram", href: "https://instagram.com" },
    { label: "Vimeo", href: "https://vimeo.com" },
    { label: "YouTube", href: "https://youtube.com" },
    { label: "LinkedIn", href: "https://linkedin.com" },
  ],
  location: "United States",
  yearsActive: "2015 \u2014 Present",
};

export const categories = [
  "Reel",
  "Sports",
  "Film",
  "Awards",
  "Series",
  "Live",
];

// VHS tape covers \u2014 pure CSS, no external images.
// Order matters: this is the on-shelf order left \u2192 right.
export const tapes = [
  {
    id: "t1",
    title: "Reel",
    subtitle: "Director's Reel",
    category: "Reel",
    year: "2025",
    runtime: "01:30",
    description:
      "A curated sizzle of recent short-form work \u2014 shot, cut, and colored across a decade of on-air and social campaigns.",
    youtubeId: "h5IATpN0-4s",
    spine: "#F0EAD6",
    body: "#1a1610",
    accent: "#C89B3C",
    stripe: "#2a2418",
  },
  {
    id: "t2",
    title: "NFL Campaign",
    subtitle: "CBS Sports",
    category: "Sports",
    year: "2024",
    runtime: "00:30",
    description:
      "Social spot cut for the NFL on CBS \u2014 game-day energy compressed into a vertical hero.",
    youtubeId: "LHtLERsPqyo",
    spine: "#4B78E4",
    body: "#08101c",
    accent: "#B7D1FF",
    stripe: "#0f1c30",
  },
  {
    id: "t3",
    title: "Dora Movie Campaign",
    subtitle: "Paramount+",
    category: "Film",
    year: "2024",
    runtime: "00:45",
    description:
      "Theatrical launch campaign for the Dora movie \u2014 a bright, playful cut tuned for feed-scrollers.",
    youtubeId: "VSSSzPIzIas",
    spine: "#D14A5E",
    body: "#180a10",
    accent: "#F4B1BF",
    stripe: "#2c101a",
  },
  {
    id: "t4",
    title: "KCA Campaign",
    subtitle: "Nickelodeon Kids' Choice Awards",
    category: "Awards",
    year: "2024",
    runtime: "00:30",
    description:
      "Countdown promo built around the biggest night in kids' TV \u2014 slime, chaos, and a whole lot of nominees.",
    youtubeId: "ammz3f1DLME",
    spine: "#E4572E",
    body: "#1a0f0a",
    accent: "#F5B14E",
    stripe: "#3a1f14",
  },
  {
    id: "t5",
    title: "Landman Campaign",
    subtitle: "Paramount+",
    category: "Series",
    year: "2024",
    runtime: "00:30",
    description:
      "Prestige-series launch cut \u2014 Texas oil, high stakes, and a tight 30 seconds of tension for social.",
    youtubeId: "8YS2ktrsEA0",
    spine: "#C97B4B",
    body: "#160e08",
    accent: "#F2C99A",
    stripe: "#2a1a10",
  },
  {
    id: "t6",
    title: "Dexter Campaign",
    subtitle: "Showtime",
    category: "Series",
    year: "2024",
    runtime: "00:30",
    description:
      "Return-of-the-franchise promo cut for Dexter \u2014 iconic silhouettes, blood-red palette, no wasted frames.",
    youtubeId: "6pVhWwfEnck",
    spine: "#7B4BFF",
    body: "#0f0a1a",
    accent: "#E1B7FF",
    stripe: "#1c1030",
  },
  {
    id: "t7",
    title: "Spongebob 25 Campaign",
    subtitle: "Nickelodeon \u00b7 25th Anniversary",
    category: "Series",
    year: "2024",
    runtime: "00:45",
    description:
      "A quarter-century of Bikini Bottom celebrated in a punchy anniversary cut, tuned for shorts and reels.",
    youtubeId: "ho0WT9I-Hgw",
    spine: "#E8A93B",
    body: "#1a1408",
    accent: "#FFE29A",
    stripe: "#2a2010",
  },
  {
    id: "t8",
    title: "Slimetime Campaign",
    subtitle: "Nickelodeon Live",
    category: "Live",
    year: "2024",
    runtime: "01:00",
    description:
      "Cross-platform hype cut for SlimeTime Live \u2014 fast, sticky, unmistakably Nickelodeon.",
    youtubeId: "vrxjF_sTtiQ",
    spine: "#2E8B7E",
    body: "#08161a",
    accent: "#9DE0C6",
    stripe: "#0f2a2a",
  },
];

export const stats = [
  { label: "Commercial & Ad Campaigns", value: "100+" },
  { label: "Shows Worked On",           value: "25+"  },
  { label: "Years of Experience",       value: "10"   },
  { label: "Memories Made",             value: "\u221E" },
];

export const services = [
  {
    title: "Shoot",
    detail:
      "Videographer / AD credits across on-set, run-and-gun, and studio shoots \u2014 I bring the camera and the plan.",
  },
  {
    title: "Cut",
    detail:
      "Short-form editor for social, YouTube, and broadcast \u2014 fast turnarounds, feed-tuned pacing, on-brand every time.",
  },
  {
    title: "Campaign",
    detail:
      "End-to-end creative on show campaigns \u2014 from concept and shoot to delivery across every platform spec.",
  },
];
